import { ColorEnum } from '../enum/color.enum';
import styled from 'styled-components';

export const ErrorWrapper = styled.div`
  text-align: center;
  background: ${ColorEnum.Red};
  color: ${ColorEnum.White};
  padding: 10px;
`;

export const InvalidWrapper = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  background: red;
  color: white;
  padding: 5px;
`;

interface ITextRowProps {
  odd?: boolean;
  disabled?: boolean;
}

export const TableRow = styled.div`
  display: flex;
  padding: 5px;
  background: ${(props: ITextRowProps) => props.odd ? ColorEnum.LightGray(props) : ColorEnum.AltoGray(props)};
  ${(props: ITextRowProps) => props.disabled ? '' : `&:hover {
    background: ${ColorEnum.AshGray(props)};
  }`}
`;

export const HeaderRow = styled.div`
  display: flex;
  padding: 5px;
  background: ${ColorEnum.LightGray};
`;

export const TableCell = styled.div`
  display: flex;
  flex: ${(props: {width?: string}) => props.width ? `0 0 ${props.width}` : '1 1 0px'};
`;
